module.exports = __webpack_public_path__ + "img/sa.f6e82bf6.jpg";